import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_BASE_URL from "../../Constants";

export const fetchEnrichedBuildingData = createAsyncThunk(
  "selectedBuilding/fetchEnriched",
  async (buildingId, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/setup/buildings/${buildingId}`,
        {
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch enriched building data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const selectedBuildingSlice = createSlice({
  name: "selectedBuilding",
  initialState: null,
  reducers: {
    setSelectedBuilding: (state, action) => {
      return action.payload;
    },
    clearSelectedBuilding: () => {
      return null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEnrichedBuildingData.pending, (state) => {
        // Can optionally add a loading indicator to the state if needed
        return state;
      })
      .addCase(fetchEnrichedBuildingData.fulfilled, (state, action) => {
        return action.payload;
      })
      .addCase(fetchEnrichedBuildingData.rejected, (state, action) => {
        // Could handle error state if needed
        console.error(
          "Failed to fetch enriched building data:",
          action.payload
        );
        return state;
      });
  },
});

export const { setSelectedBuilding, clearSelectedBuilding } =
  selectedBuildingSlice.actions;
export const selectedBuilding = (state) => state.selectedBuilding;

export default selectedBuildingSlice.reducer;
